import { useTheme } from "@hooks";
import { spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const borderColor = encodeURIComponent(theme.accounts.item.empty.default);

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='100%25' height='100%25' fill='none' stroke='${borderColor}' stroke-width='4' stroke-dasharray='6%2C 14' stroke-dashoffset='0' stroke-linecap='square'/%3E%3C/svg%3E")`,
      borderRadius: 8,
      justifyContent: "center",
      alignItems: "center",
      paddingTop: spacing.xl,
      paddingBottom: spacing.xl,
      userSelect: "none",
      cursor: "pointer",
    },
    inner: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
  };

  return styles;
};
